// extracted by mini-css-extract-plugin
export default {"timeline":"delivery-status-timeline_timeline__T4asa"};